import React from 'react';
import { Flexbox } from '@sonika-se/ui-kit/components';
export const EditableListContent = (props) => {
    const { children } = props;
    return (<Flexbox direction="column" gap="xsmall">
      {children}
    </Flexbox>);
};
export default EditableListContent;
